import { AnyAction } from "redux";
import { SET_BOOKMARKS_LOADED } from "../actions/loadingBookmarks";

export const loadingBookmarks = (state = false, action: AnyAction) => {
  switch (action.type) {
    case SET_BOOKMARKS_LOADED:
      return action.bookmarksLoaded;
    default:
      return state;
  }
};

export default loadingBookmarks;
